import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        Mumbai Central -400008, Maharashtra, India.
      </li>
      <li>
  <a
    href="tel:+91 9988220981"
    className="text-decoration-none text-reset d-flex align-items-center"
  >
    <i className="cs_accent_bg me-2">
      <Icon icon="fluent:call-24-regular" />
    </i>
    +91 9988220981
  </a>
</li>

<li>
  <a
    href="mailto:info@precisionorthocad.in"
    className="text-decoration-none text-reset d-flex align-items-center"
  >
    <i className="cs_accent_bg me-2">
      <Icon icon="bi:envelope" />
    </i>
    info@precisionorthocad.in
  </a>
</li>
    </ul>
  );
}
